import { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/Container';
// import { Link } from 'react-router-dom';
import { NavLink, useLocation } from 'react-router-dom';
// import logo from '../Img/Bharat-removebg-preview.png';
import logo1 from '../Img/Bharat-Rug Logo.jpg';
// import './Navbar.css';
import './Navbar3.css';
import { Nav, Navbar, NavDropdown, Offcanvas, Image } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";


function BasicExample() {

  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false); // <-- control navbar

  const location = useLocation();
  const navigate = useNavigate();


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => setExpanded(false); // close after click

  // check if current path is one of the Products children
  const isProductsPage = [
    // "/Furniture",
    "/Product",
    "/Rugs",
    "/Cushions",
    // "/BedBath",
    // "/KitchenDining",
    "/Accessories",
    "/Lighting",
    "/Bags",
    // "/Holiday"
  ].some(path => location.pathname.startsWith(path));

  return (

    <>
      <Navbar
        collapseOnSelect
        expand="xl"
        expanded={expanded}               // controlled state
        onToggle={setExpanded}            // keep state in sync
        className={`custom-navbar ${scrolled ? 'scrolled' : ''}`}
        variant="light"
        sticky="top"
      //  fixed="top"
      >
        <Navbar.Brand
          as={NavLink}
          to="/"
          onClick={handleNavClick}
          className="d-flex align-items-center gap-2 brand-title"
        >
          {/* <Image src={logo1} alt="logo" className="brand-logo" /> */}
          <Image src={logo1} alt="logo" className="brand-logo" roundedCircle />
          <h1 className="text-primary main-heading">Bharat Rug Agencies</h1>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expanded}`} />
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-${expanded}`}
          aria-labelledby={`offcanvasNavbarLabel-expand-${expanded}`}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expanded}`}>
              <Navbar.Brand as={NavLink} to="/" onClick={handleNavClick}>
                {/* <Image src={logo} alt="logo" height={80} /> */}
                <Image src={logo1} alt="logo" height={80} roundedCircle />
              </Navbar.Brand>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 mx-4">
              <Nav.Link as={NavLink} to="/" className="px-4 fs-6" onClick={handleNavClick}>Home</Nav.Link>
              <Nav.Link as={NavLink} to="/Services" className="px-4 fs-6" onClick={handleNavClick}>Services</Nav.Link>

              <NavDropdown
                className={`px-4 fs-6 ${isProductsPage ? "active" : ""}`}
                title={
                  <span
                    onClick={() => {
                      handleNavClick();
                      navigate("/Product");
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Products
                  </span>
                }
                popperConfig={{ strategy: "fixed" }}
              >

                {/* <NavDropdown.Item className='fs-6' as={NavLink} to="/Furniture" onClick={handleNavClick}>Furniture</NavDropdown.Item> */}
                <NavDropdown.Item className='fs-6' as={NavLink} to="/Rugs" onClick={handleNavClick}>Rugs</NavDropdown.Item>
                <NavDropdown.Item className='fs-6' as={NavLink} to="/Cushions" onClick={handleNavClick}>Cushions</NavDropdown.Item>
                {/* <NavDropdown.Item className='fs-6' as={NavLink} to="/BedBath" onClick={handleNavClick}>Bed & Bath</NavDropdown.Item>
              <NavDropdown.Item className='fs-6' as={NavLink} to="/KitchenDining" onClick={handleNavClick}>Kitchen & Dining</NavDropdown.Item> */}
                <NavDropdown.Item className='fs-6' as={NavLink} to="/Towel" onClick={handleNavClick}>Towels</NavDropdown.Item>
                <NavDropdown.Item className='fs-6' as={NavLink} to="/Pouf" onClick={handleNavClick}>Poufs</NavDropdown.Item>
                <NavDropdown.Item className='fs-6' as={NavLink} to="/Curtain" onClick={handleNavClick}>Curtain</NavDropdown.Item>
                {/* <NavDropdown.Item className='fs-6' as={NavLink} to="/Holiday" onClick={handleNavClick}>Holiday</NavDropdown.Item> */}
              </NavDropdown>


              {/* <Nav.Link as={NavLink} to="/WhyUs" className="px-4 fs-6" onClick={handleNavClick}>Why Us</Nav.Link> */}
              <Nav.Link as={NavLink} to="/About" className="px-4 fs-6" onClick={handleNavClick}>Trade Show</Nav.Link>
              <Nav.Link as={NavLink} to="/Contact" className="px-4 fs-6" onClick={handleNavClick}>Contact Us</Nav.Link>

            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Navbar>
    </>
  );
}

export default BasicExample;

